module.exports = __webpack_public_path__ + "img/1106e_2.99ce8fb4.jpg";